import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { getData } from "../../services/base.service";
import PartnerForm from "./PartnerForm";
import { PartnerDetailsType, PartnersAvailableOptions } from "../../types/dataTypes";
import CustomDialog from "../Shared/CustomDialog";

type AddPartnerProps = {
    setLoading: Function,
    setFilters: Function,
    isDrawerOpen: boolean,
    setIsDrawerDetailsOpen: Function
    setReload: Function
  }
  
  function AddPartner({ setLoading,  setFilters, isDrawerOpen, setIsDrawerDetailsOpen, setReload }: 
    AddPartnerProps) {
    const [partnerOptions, setPartnerOptions] = useState<PartnersAvailableOptions>();
    const [partnerData, setPartnerData] = useState<PartnerDetailsType>();    

    const fetchPartnerOptions = async () => {
        getData(`partners/getAvailableOptions`).then((response) => {
            setPartnerOptions(response);
            setPartnerData(createEmptyPartner());
        })
        .catch((error) => {
            setLoading(false);
            console.error("Error fetching partner options:", error);
        });
        
    };

    useEffect(() => {
        setLoading(true);
        fetchPartnerOptions();
        setLoading(false);
    },[]);

    const createEmptyPartner = (): PartnerDetailsType => ({
        contact: {
            name: '', short_name: '', headquarter: '', email: '', 
            address: '', phone: '', contact_persons: []
        },
        profile: {
            fos: [], countries: [], logo: null, folder: null, 
            remark: null, website: null
        },
        collab_history: [],
        experts: [],
        housekeeping: {
            created_at: new Date(), created_by: '', 
            updated_at: new Date(), updated_by: ''
        }
    });

    return (
        partnerOptions ? ( // Check if expertData and expertData.expertsDetails are not null before rendering
            <Grid>
              <CustomDialog open={isDrawerOpen} onClose={() => setIsDrawerDetailsOpen(false)} maxWidth="lg" title={'Add a new Partner'}>
                  <PartnerForm type='add' setLoading={setLoading} partnerData={partnerData}
                  setFilters={setFilters} setDetailsDrawerOpen={setIsDrawerDetailsOpen} partnerOptions={partnerOptions}
                  setReload={setReload}/>
                </CustomDialog>
            </Grid>
      ) : null // Render nothing if expertData or expertData.expertsDetails is null
    )
  }
  
  export default AddPartner;



